










































import Vue from 'vue'
import {SELL_CHESS, DISPATCH_CHESS} from '@/common/mutation-types'
import {Chess} from '@/common/types'

export default Vue.extend({
  name: 'Preparation',
  computed: {
    battlefield(): Chess[] {
      return this.$store.state.gameInfo.battlefield
    },
    preparation(): Chess[] {
      return this.$store.state.gameInfo.preparation
    },
  },
  methods: {
    drag(event: any, num: number) {
      event.dataTransfer.setData(DISPATCH_CHESS, JSON.stringify(num))
    },
    dispatchChess(num: number) {
      const availablePositions = new Set(
        Array.from({length: 32}, (v, i) => i + 33),
      )
      this.battlefield.forEach(chess => {
        if (!chess.position) return
        availablePositions.delete(
          (chess.position.row - 1) * 8 + chess.position.col,
        )
      })

      // Return if all positions have been taken
      if (availablePositions.size === 0) return

      // Set the target
      const target = Math.min(...availablePositions)

      // Dispatch current chess to the target position
      this.$store.commit(DISPATCH_CHESS, {
        num: num,
        targetPosition: {
          row: Math.trunc((target - 1) / 8) + 1,
          col: ((target - 1) % 8) + 1,
        },
      })
    },
    sellChess(num: number) {
      this.$store.commit(SELL_CHESS, num)
    },
  },
})
